import type { FilterFunc, SearchSummary } from '@tunasong/models'
import type { Entity, SearchRequest } from '@tunasong/schemas'
import { SearchResults, type SearchResultsProps } from './search-results.js'
import { useAdvancedSearch } from './search.hook.js'

export interface SearchListProps
  extends Omit<SearchResultsProps, 'entities' | 'onChange' | 'onEndOfResults' | 'inputRef'> {
  query?: SearchRequest

  /** Fetch size for getNext */
  fetchSize?: number
  inputRef?: HTMLElement | null
  resultFilter?: FilterFunc
  selected?: Pick<Entity, 'id'>
  onChange(summary: SearchSummary): void
}

export function SearchList(props: SearchListProps) {
  const { query, fetchSize, inputRef, resultFilter, onChange, selected, ...restProps } = props

  /** @todo filter on type */
  const { results, searching, getNext } = useAdvancedSearch(query, {
    resultFilter,
    debounceDelay: 0,
    size: fetchSize,
    queryType: 'type',
  })

  return (
    <SearchResults
      {...restProps}
      searching={searching}
      inputRef={inputRef}
      entities={results}
      onChange={onChange}
      onEndOfResults={getNext}
      selectedIndex={results.findIndex(r => r.id === selected?.id)}
    />
  )
}
